import { intersection } from 'lodash';
import { sidebarItems } from 'utils/consts/sidebarItems';

export const filterSideBar = (roles: string[]) =>
  sidebarItems
    .map((sidebarItem) => ({
      ...sidebarItem,
      submenu: sidebarItem.submenu.filter((submenuItem) => {
        if (!submenuItem.roles) {
          return true;
        }
        return !!intersection(roles, submenuItem.roles).length;
      }),
    }))
    .filter((el) => !!el.submenu.length);
